import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '@env/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomToastComponent } from './core/custom.toast.component';

import { CoreModule } from './core';
//import { AuthService } from './core/auth.service';
import { DashboardModule } from './dashboard/dashboard.module';
import { TrxnModule } from './transaction/transaction.module';
import { AuthModule } from './auth/auth.module';
import { DrawModule } from './draw/draw.module';
import { EkubModule } from './ekub/ekub.module';
import { AdminModule } from './admin/admin.module';
import { AdModule } from './ad/ad.module';
import { MiscModule } from './misc/misc.module';
import { AnalyticsModule } from './analytics/analytics.module';
import { ReportModule } from './report/report.module';
import { RestangularModule, Restangular } from 'ngx-restangular';
import { FusionChartsModule } from 'angular-fusioncharts';
import * as FusionCharts from 'fusioncharts';
import * as charts from 'fusioncharts/fusioncharts.charts';
import * as PowerCharts from "fusioncharts/fusioncharts.powercharts";
import * as TimeSeries from 'fusioncharts/fusioncharts.timeseries'; // Import timeseries
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import { FormsModule } from '@angular/forms';
import { LaddaModule } from 'angular2-ladda';
//import { ToastNotificationsModule } from "ngx-toast-notifications";
import { TOAST_NOTIFICATIONS_CONFIG, ToastNotificationsModule, Toast, ToastConfig, Toaster, ToastType } from "ngx-toast-notifications";
/* import { NgSelectModule } from '@ng-select/ng-select'; */
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxWheelModule } from 'ngx-wheel';
import { NgxDropzoneModule } from 'ngx-dropzone';
/* import { ToastyModule } from 'ng2-toasty'; */
FusionChartsModule.fcRoot(FusionCharts, charts, FusionTheme, PowerCharts, TimeSeries);

export function RestangularConfigFactory(RestangularProvider: any) {
  //RestangularProvider.setBaseUrl('https://debo.kavanatech.net/api/');
  RestangularProvider.setBaseUrl(environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL);

  RestangularProvider.setDefaultHeaders({ Authorization: 'Bearer ' + localStorage.getItem('access_token') });


  /*  RestangularProvider.addResponseInterceptor((data, operation, what, url, response)=> {
     return data;
   }); */

  /*   RestangularProvider.addErrorInterceptor((response, subject, responseHandler) => {
      if (response.status === 401) {
        debugger;
        //redirect to login
        AuthService.redirectToLogin();
        return false;
      }
      if (response.status === 403) {
        return false; // error handled
      }
      return true; // error not handled
    }); */


}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    FormsModule,
    RestangularModule.forRoot(RestangularConfigFactory),
    FusionChartsModule,
    NgxDropzoneModule,
    NgxWheelModule,
    ToastNotificationsModule,
    LaddaModule,
    CoreModule,
    AuthModule,
    DrawModule,
    DashboardModule,
    TrxnModule,
    EkubModule,
    MiscModule,
    AdModule,
    AdminModule,
    AnalyticsModule,
    ReportModule,
    AppRoutingModule,
  ],
  //providers: [],
  providers: [
    { provide: TOAST_NOTIFICATIONS_CONFIG, useValue: { component: CustomToastComponent } },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
